export const list_reducer = (state, action) => {
  const { payload } = action;
  return {
    objects: payload.data.reduce((objects, object) => ({...objects, [object.id]: object}), {}),
    orderedIds: payload.data.map(object => object.id),
    totalCount: payload.recordsTotal,
    filteredCount: payload.recordsFiltered,
  };
};

export const update_reducer = (state, action) => {
  return {
    objects: {
      ...state.objects,
      [action.payload.id]: action.payload,
    },
  };
};

export const delete_reducer = (state, action) => {
  const { id: deletedId } = action.payload;
  return {
    objects: (() => {
      let cloned = { ...state.objects };
      delete cloned[deletedId];
      return cloned;
    })(),
    orderedIds: state.orderedIds.filter(id => id !== deletedId),
  };
};

export const add_reducer = (state, action) => {
  const { id: addedId } = action.payload;
  return {
    objects: {
      ...state.objects,
      [addedId]: action.payload,
    },
    orderedIds: [addedId, ...state.orderedIds],
  };
};

export const add_to_list_reducer = (state, targetObjectId, addedChildObject, key) => {
  return {
    objects: {
      ...state.objects,
      [targetObjectId]: {
        ...state.objects[targetObjectId],
        [key]: [addedChildObject, ...state.objects[targetObjectId][key]],
      },
    },
  };
};

export const update_in_list_reducer = (state, targetObjectId, updatedChildObject, key) => {
  return {
    objects: {
      ...state.objects,
      [targetObjectId]: {
        ...state.objects[targetObjectId],
        [key]: state.objects[targetObjectId][key].map(
          child => child.id === updatedChildObject.id ? updatedChildObject : child
        ),
      },
    },
  };
};

export const delete_in_list_reducer = (state, targetObjectId, deletedChildId, key) => {
  return {
    objects: {
      ...state.objects,
      [targetObjectId]: {
        ...state.objects[targetObjectId],
        [key]: state.objects[targetObjectId][key].filter(child => child.id !== deletedChildId),
      },
    },
  };
};



// WEBPACK FOOTER //
// ./src/redux/reducers.js